(function () {
  'use strict';
  if (window.EnigmaAvailabilityRequestReady) return;
  window.EnigmaAvailabilityRequestReady = true;
  function productContext(trigger) {
    var productForm = trigger.closest('form');
    var scope = trigger.closest('.product-template__container[data-product-instance-id], .product-single, .product-single__sticky, .product-single__stick-add');
    var explicit = trigger.hasAttribute('data-enigma-availability-trigger');
    if (explicit && (trigger.hidden || trigger.disabled)) return null;
    var input = productForm && productForm.querySelector('[data-variant-id-input][name="id"], input[name="id"], select[name="id"]');
    var variant = explicit ? trigger.dataset.availabilityVariantId : (productForm && productForm.dataset.currentVariantId) || (input && input.value);
    if (!/^\d+$/.test(String(variant || ''))) return null;
    var state = productForm && productForm.dataset.productState;
    if (explicit && state && state !== 'sold-out') {
      var priceGuard = window.EnigmaSealedPriceGuard;
      if (state !== 'price-unavailable' || !input || String(input.value) !== String(variant)
        || (productForm.dataset.currentVariantId && String(productForm.dataset.currentVariantId) !== String(variant))
        || !priceGuard || typeof priceGuard.isBlocked !== 'function' || !priceGuard.isBlocked(productForm, {id: variant})) return null;
    }
    var variantControl = scope && scope.querySelector('[data-product-url]');
    var title = trigger.dataset.availabilityProduct || (scope && scope.querySelector('.product-single__title, .product__title') || {}).textContent || '';
    var productPath = trigger.dataset.availabilityProductUrl || (variantControl && variantControl.dataset.productUrl);
    var handleElement = trigger.hasAttribute('data-handle') ? trigger : trigger.querySelector('[data-handle]');
    var handle = handleElement && handleElement.dataset.handle;
    if (!productPath && /^[a-z0-9][a-z0-9-]*$/.test(handle || '')) productPath = '/products/' + handle;
    if (!productPath || !title.trim()) return null;
    var productUrl;
    try { productUrl = new URL(productPath, window.location.origin); } catch (_) { return null; }
    if (productUrl.origin !== window.location.origin || !/\/products\/[^/]+\/?$/.test(productUrl.pathname)) return null;
    productUrl.search = ''; productUrl.hash = ''; productUrl.searchParams.set('variant', variant);
    var productId = trigger.dataset.availabilityProductId || '';
    if (!/^\d+$/.test(productId)) productId = '';
    return { title: title.trim(), productId: productId, variant: String(variant), url: productUrl.href };
  }
  document.addEventListener('click', function (event) {
    var trigger = event.target && event.target.closest && event.target.closest('[data-target="#Form_newletter"], [href="#Form_newletter"]');
    if (!trigger) return;
    var form = document.getElementById('EnigmaAvailabilityRequest');
    if (!form) return;
    var context = productContext(trigger);
    if (!context) {
      // Do not open a request tied to a previous product or nonexistent option.
      event.preventDefault(); event.stopImmediatePropagation(); return;
    }
    var fields = {
      '[data-enigma-availability-product]': context.title,
      '[data-enigma-availability-product-id]': context.productId,
      '[data-enigma-availability-variant]': context.variant,
      '[data-enigma-availability-url]': context.url
    };
    Object.keys(fields).forEach(function (selector) { var field = form.querySelector(selector); if (field) field.value = fields[selector]; });
    var label = document.querySelector('[data-enigma-availability-product-label]');
    if (label) label.textContent = context.title;
    var message = form.querySelector('[data-enigma-availability-message]');
    if (message && (!message.value || message.value === message.dataset.availabilityDefault)) {
      message.value = (message.dataset.availabilityPrefix || '') + context.title + '.';
      message.dataset.availabilityDefault = message.value;
    }
    // The customer reviews and submits the normal Shopify contact form manually.
  }, true);
})();
